import React from 'react';
import { AEyebrow } from '../../atoms/AEyebrow/index';
import { AHeader } from '../../atoms/AHeader/index';
import { ABody } from '../../atoms/ABody/index';
import * as Styled from './MTextBlockInteractive.styles';
import type { MTextBlockInteractiveProps, MTextBlockInteractiveAlignment } from './MTextBlockInteractive.types';

const COMPONENT_NAME = 'm-web-ui-kit-MTextBlockInteractive';
export const M_TEXT_BLOCK_INTERACTIVE_TEST_ID = 'web-ui-kit-MTextBlockInteractive';

export const MTextBlockInteractive: React.FC<MTextBlockInteractiveProps> = ({
  // alignment, // TODO: Add alignment styling
  eyebrowText,
  eyebrowVariant,
  headerText,
  headerSize,
  headerElement,
  bodyText,
  bodySize,
  bodyColor,
  className,
  ...rest
}) => {
  return (
    <Styled.Wrapper
      data-component-name={COMPONENT_NAME}
      data-testid={M_TEXT_BLOCK_INTERACTIVE_TEST_ID}
      className={className}
      {...rest}
    >
      {eyebrowText && <AEyebrow eyebrowText={eyebrowText} variant={eyebrowVariant} />}
      {headerText && <AHeader text={headerText} size={headerSize} element={headerElement} />}
      {bodyText && <ABody bodyText={bodyText} size={bodySize} color={bodyColor} />}
    </Styled.Wrapper>
  );
};

export * from './MTextBlockInteractive.types';
